import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgSdk = function SvgSdk(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_129_7614",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_129_7614)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_129_7614)",
        fillOpacity: 0.16,
        d: "M15.347 65.987q1.347 1.346 3.268 1.346h50.77q1.92 0 3.268-1.346T74 62.718V25.282q0-1.92-1.347-3.268t-3.268-1.347h-50.77q-1.92 0-3.268 1.347T14 25.282v37.436q0 1.921 1.347 3.269"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_129_7614)",
        d: "M14.615 63.333q-1.92 0-3.268-1.347T10 58.718V21.282q0-1.921 1.347-3.268t3.268-1.347h50.77q1.92 0 3.268 1.346T70 21.283v37.436q0 1.92-1.347 3.268t-3.268 1.347zm0-2.564h50.77q.769 0 1.41-.64.64-.642.64-1.411v-32.68h-54.87v32.68q0 .77.64 1.41.642.642 1.41.641m17.2-17.333-7.75-7.814q-.367-.301-.384-.847a1.14 1.14 0 0 1 .402-.922q.366-.366.917-.334.55.032.917.398l7.897 7.897q.686.68.686 1.587t-.686 1.592l-7.961 7.962q-.366.429-.872.366a1.58 1.58 0 0 1-.898-.43q-.365-.366-.365-.82 0-.456.365-.821zm11.518 11.282q-.568 0-.925-.357t-.357-.926.357-.925q.357-.357.925-.356h13.334q.568 0 .925.357.357.356.357.926t-.357.925q-.357.356-.925.356z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_129_7614",
        x1: 14.627,
        x2: 73.165,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_129_7614",
        x1: 10.627,
        x2: 69.165,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgSdk as ReactComponent };
//# sourceMappingURL=SDK.svg.es.js.map
